import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Navigate } from 'react-router-dom';

import Loading from '../../../Libs/Helper/Loading';
import { LogoutReducer } from '../Reducer/LoginReducer';
export class Logout extends Component {


    constructor(props) {
        super(props);

        this.state = {
            token: true
        }

    }

    componentDidMount() {
        this.removeToken();

    }


    removeToken = async () => {
        try {

            this.props.LogoutReducer()

            this.setState({
                token: false
            })
        } catch (e) {

        }
    }
    render() {
       
        return (
            <>
                {this.state.token ? <Loading /> :
                    <Navigate to="/Login" />
                }
            </>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {
    LogoutReducer
}

export default connect(mapStateToProps, mapDispatchToProps)(Logout)